"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSideBranch = exports.setActiveTraceState = exports.addClusterToTrace = exports.setActiveTrace = exports.addEdgeToActive = exports.removeClusterFromStories = exports.setActiveStory = exports.addClusterToStory = exports.setStories = exports.deleteStory = exports.addStory = void 0;
const graphs_1 = require("../util/graphs");
const ADD_STORY_BOOK = "ducks/stories/ADD";
const DELETE = "ducks/stories/DELETE";
const SET = "ducks/stories/SET";
const ADD_CLUSTER_TO_ACTIVE = "ducks/stories/ADD_CLUSTER";
const SET_ACTIVE_STORY_BOOK = "ducks/stories/SET_ACTIVE";
const REMOVE_CLUSTER_FROM_STORIES = "ducks/stories/REMOVE_CLUSTER_FROM_STORIES";
const ADD_EDGE_TO_ACTIVE = "ducks/stories/ADD_EDGE_TO_ACTIVE";
const SET_ACTIVE_TRACE = "ducks/stories/SET_ACTIVE_TRACE";
const ADD_CLUSTER_TO_TRACE = "ducks/stories/ADD_CLUSTER_TO_TRACE";
const SET_ACTIVE_TRACE_STATE = "ducks/stories/SET_ACTIVE_TRACE_STATE";
const SELECT_SIDE_BRANCH = "ducks/stories/SELECT_SIDE_BRANCH";
exports.addStory = story => ({
    type: ADD_STORY_BOOK,
    story: story
});
exports.deleteStory = story => ({
    type: DELETE,
    story: story
});
function setStories(stories) {
    return {
        type: SET,
        stories: stories
    };
}
exports.setStories = setStories;
exports.addClusterToStory = cluster => ({
    type: ADD_CLUSTER_TO_ACTIVE,
    cluster: cluster
});
function setActiveStory(activeStory) {
    return {
        type: SET_ACTIVE_STORY_BOOK,
        activeStory: activeStory
    };
}
exports.setActiveStory = setActiveStory;
function removeClusterFromStories(cluster) {
    return {
        type: REMOVE_CLUSTER_FROM_STORIES,
        cluster: cluster
    };
}
exports.removeClusterFromStories = removeClusterFromStories;
function addEdgeToActive(edge) {
    return {
        type: ADD_EDGE_TO_ACTIVE,
        edge: edge
    };
}
exports.addEdgeToActive = addEdgeToActive;
exports.setActiveTrace = activeTrace => ({
    type: SET_ACTIVE_TRACE,
    activeTrace: activeTrace
});
exports.addClusterToTrace = cluster => ({
    type: ADD_CLUSTER_TO_TRACE,
    cluster: cluster
});
function setActiveTraceState(cluster) {
    return {
        type: SET_ACTIVE_TRACE_STATE,
        cluster: cluster
    };
}
exports.setActiveTraceState = setActiveTraceState;
function selectSideBranch(i) {
    return {
        type: SELECT_SIDE_BRANCH,
        index: i
    };
}
exports.selectSideBranch = selectSideBranch;
const initialState = {
    stories: [],
    active: null,
    trace: null,
    activeTraceState: null
};
function stories(state = initialState, action) {
    switch (action.type) {
        case SELECT_SIDE_BRANCH: {
            let sidePaths = state.trace.sidePaths.slice(0);
            sidePaths.splice(action.index, 1);
            sidePaths.push({ nodes: state.trace.mainPath, edges: state.trace.mainEdges });
            let trace = {
                mainPath: state.trace.sidePaths[action.index].nodes,
                mainEdges: state.trace.sidePaths[action.index].edges,
                sidePaths: sidePaths
            };
            return {
                stories: state.stories,
                active: state.active,
                trace: trace,
                activeTraceState: state.activeTraceState
            };
        }
        case SET_ACTIVE_TRACE_STATE: {
            return {
                stories: state.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: action.cluster
            };
        }
        case ADD_CLUSTER_TO_TRACE: {
            let cluster = action.cluster;
            // Add cluster to active story book
            state.active.clusters.push(cluster);
            // Add edge that connects the active trace state with the current cluster
            if (state.trace.mainPath.length > 0) {
                let edge = new graphs_1.Edge(state.trace.mainPath[state.trace.mainPath.length - 1], cluster, null);
                state.active.edges.push(edge);
                state.trace.mainEdges.push(edge);
            }
            // Add cluster to current trace
            state.trace.mainPath.push(cluster);
            return {
                stories: state.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        }
        case SET_ACTIVE_TRACE: {
            return {
                stories: state.stories,
                active: state.active,
                trace: action.activeTrace,
                activeTraceState: state.activeTraceState
            };
        }
        case SET:
            return {
                stories: action.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        case DELETE:
            const newState = state.stories.slice(0);
            newState.splice(newState.indexOf(action.story), 1);
            return {
                stories: newState,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        case ADD_STORY_BOOK: {
            let storyBook = action.story;
            let trace = state.trace;
            let activeTraceState = state.activeTraceState;
            if (storyBook.clusters.length == 0) {
                trace = {
                    mainEdges: [],
                    mainPath: [],
                    sidePaths: []
                };
                activeTraceState = null;
            }
            if (state && state.stories.length > 0) {
                const newState = state.stories.slice(0);
                newState.push(storyBook);
                return {
                    stories: newState,
                    active: storyBook,
                    trace: trace,
                    activeTraceState: activeTraceState
                };
            }
            else {
                return {
                    stories: [storyBook],
                    active: storyBook,
                    trace: trace,
                    activeTraceState: activeTraceState
                };
            }
        }
        case SET_ACTIVE_STORY_BOOK: {
            let storyBook = action.activeStory;
            let trace = state.trace;
            let activeTraceState = state.activeTraceState;
            if (storyBook && storyBook.clusters.length == 0) {
                trace = {
                    mainPath: [],
                    mainEdges: [],
                    sidePaths: []
                };
                activeTraceState = null;
            }
            else {
                trace = null;
            }
            return {
                stories: state.stories,
                active: action.activeStory,
                trace: trace,
                activeTraceState: activeTraceState
            };
        }
        case REMOVE_CLUSTER_FROM_STORIES: {
            let cluster = action.cluster;
            // Find stories where the cluster is located
            state.stories.forEach(story => {
                if (story.clusters.includes(cluster)) {
                    story.clusters.splice(story.clusters.indexOf(cluster), 1);
                    story.edges.filter(edge => {
                        return edge.source == cluster || edge.destination == cluster;
                    }).forEach(edge => {
                        story.edges.splice(story.edges.indexOf(edge), 1);
                    });
                }
            });
            // Remove cluster labels from samples
            // TODO: check if this is ok in a reducer
            cluster.vectors.forEach(sample => {
                if (Array.isArray(sample.clusterLabel)) {
                    sample.clusterLabel.splice(sample.clusterLabel.indexOf(cluster.label), 1);
                }
                else {
                    sample.clusterLabel = [];
                }
            });
            return {
                stories: state.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        }
        case ADD_EDGE_TO_ACTIVE: {
            state.active.edges.push(action.edge);
            return {
                stories: state.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        }
        case ADD_CLUSTER_TO_ACTIVE: {
            let cluster = action.cluster;
            state.active.clusters.push(cluster);
            // Add cluster labels to samples
            // TODO: check if this is ok in a reducer
            cluster.vectors.forEach(sample => {
                if (Array.isArray(sample.clusterLabel)) {
                    sample.clusterLabel.push(cluster.label);
                }
                else {
                    sample.clusterLabel = [cluster.label];
                }
            });
            return {
                stories: state.stories,
                active: state.active,
                trace: state.trace,
                activeTraceState: state.activeTraceState
            };
        }
        default:
            return state;
    }
}
exports.default = stories;
